import React from 'react'
import PropTypes from 'prop-types'
import TextInput from '../../inputs/text-input'
import TextArea from '../../inputs/text-area'
import PhotoInput from '../../inputs/photo-input'
import SelectInput from '../../inputs/select-input'

const GenerealInfo = ({ hidden, locationName, register, errors, setValue, photoUrl, onFileLoaded, onNameChanged }) => {
  const requiredMsg = 'Is required'

  const loadFile = (file) => {
    const fr = new FileReader()
    fr.onloadend = function() { 
      setValue('photo_url', fr.result)
      onFileLoaded(file.name)
    }
    fr.readAsDataURL(file)
  }

  const fileSelected = (file) => {
    if(file.size > 10000000) return window.alert('File size limit is 10MB')
    if (!['image/jpeg', 'image/png'].includes(file.type)) return window.alert(' Only JPG and PNG files are allowed')

    loadFile(file)
  }

  const changeName = (e) => {
    const value = e.target.value
    setValue('name', value)
    onNameChanged(value)
  }

  const validateName = (value) => {
    if (!value.trim()) return requiredMsg
  }

  return <div className='step-section' hidden={hidden}>
    <div className='section-title'>General Info</div>
    <div className='team-name-location'>
      <TextInput
        {...register('name', { required: requiredMsg, validate: validateName })}
        label='Team Name'
        error={errors.name}
        onChange={changeName}
      />
      <SelectInput 
        disabled
        options={[locationName]}
        value={locationName}
        label='Location'
      />
    </div>
    <TextArea
      {...register('about')}
      label='About the team'
      onChange={(e) => setValue('about', e.target.value)}
    />
    <PhotoInput photoUrl={photoUrl} onFileLoad={fileSelected} />
  </div>
}

GenerealInfo.propTypes = {
  hidden: PropTypes.bool.isRequired,
  locationName: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  photoUrl: PropTypes.string,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  onFileLoaded: PropTypes.func.isRequired,
  onNameChanged: PropTypes.func.isRequired,
}

export default GenerealInfo
